import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Tokushoho() {
	return (
		<main className="min-h-screen bg-white">
			<Helmet>
				<title>特定商取引法に基づく表記 | しろぬきや</title>
			</Helmet>
			<header className="border-b border-gray-100 bg-white sticky top-0 z-10">
				<div className="max-w-3xl mx-auto px-4 py-3 flex items-center gap-2">
					<Link
						to="/"
						className="flex items-center gap-2 hover:opacity-80 transition"
					>
						<span className="text-2xl">✂️</span>
						<span className="font-bold text-lg text-gray-900">しろぬきや</span>
					</Link>
				</div>
			</header>

			<div className="max-w-3xl mx-auto px-4 py-12">
				<h1 className="text-3xl font-bold text-gray-900 mb-2">
					特定商取引法に基づく表記
				</h1>
				<p className="text-sm text-gray-500 mb-10">最終更新日: 2026年3月18日</p>

				<div className="space-y-0 text-gray-700 leading-relaxed">
					<table className="w-full border-collapse">
						<tbody>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									販売事業者名
								</th>
								<td className="py-4 text-gray-700">しろぬきや</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									所在地
								</th>
								<td className="py-4 text-gray-700">
									千葉県習志野市実籾4-3-7 エクセルみもみ203
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									連絡先
								</th>
								<td className="py-4 text-gray-700">
									<Link to="/contact" className="text-blue-600 hover:underline">
										お問い合わせフォーム
									</Link>
									<br />
									メールアドレス: support@fucina.casa
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									販売URL
								</th>
								<td className="py-4 text-gray-700">
									<a
										href="https://shironukiya.fucina.casa"
										className="text-blue-600 hover:underline"
										target="_blank"
										rel="noopener noreferrer"
									>
										https://shironukiya.fucina.casa
									</a>
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									販売価格
								</th>
								<td className="py-4 text-gray-700">
									<p>月額プラン: ¥500（税込）</p>
									<p>年額プラン: ¥5,000（税込）</p>
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									支払方法
								</th>
								<td className="py-4 text-gray-700">
									クレジットカード（Stripe経由）
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									支払時期
								</th>
								<td className="py-4 text-gray-700">
									購入手続き完了時に即時課金。以降、契約期間（月次または年次）に応じて自動更新
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									サービス提供時期
								</th>
								<td className="py-4 text-gray-700">決済完了後、即時利用可能</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									返品・キャンセル
								</th>
								<td className="py-4 text-gray-700">
									デジタルサービスの性質上、返品・返金はお受けできません。
									サブスクリプションはいつでも解約可能です（解約後も次回更新日まで継続してご利用いただけます）。
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									解約方法
								</th>
								<td className="py-4 text-gray-700">
									マイページのStripe Customer Portalよりお手続きいただけます。
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									代表者名
								</th>
								<td className="py-4 text-gray-700">鈴木 直人</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									電話番号
								</th>
								<td className="py-4 text-gray-700">
									電話番号なし。メール:
									support@fucina.casa、またはお問い合わせフォームよりご連絡ください。
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									商品代金以外の必要料金
								</th>
								<td className="py-4 text-gray-700">なし（税込価格表示）</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									申込みの有効期限
								</th>
								<td className="py-4 text-gray-700">特に定めなし</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									販売数量の制限
								</th>
								<td className="py-4 text-gray-700">特に定めなし</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									ソフトウェアの動作環境
								</th>
								<td className="py-4 text-gray-700">
									Google Chrome、Mozilla Firefox、Apple Safari、Microsoft
									Edge（各最新版）
								</td>
							</tr>
							<tr className="border-b border-gray-200">
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									契約不適合責任
								</th>
								<td className="py-4 text-gray-700">
									サービスに不具合が生じた場合は、速やかに修正対応いたします。
								</td>
							</tr>
							<tr>
								<th className="text-left py-4 pr-6 w-40 text-gray-900 font-semibold align-top">
									継続的契約の条件
								</th>
								<td className="py-4 text-gray-700">
									<p>契約期間: 月額プランは1ヶ月、年額プランは1年</p>
									<p>契約期間終了後は自動更新されます。</p>
									<p>
										解約はいつでも可能です。解約後も契約期間終了日まで引き続きご利用いただけます。
									</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<footer className="text-center py-8 text-gray-400 text-sm border-t border-gray-100">
				<p>© 2026 しろぬきや</p>
				<div className="mt-2 flex justify-center gap-4">
					<Link to="/terms" className="hover:text-gray-600 transition">
						利用規約
					</Link>
					<Link to="/privacy" className="hover:text-gray-600 transition">
						プライバシーポリシー
					</Link>
					<Link to="/tokushoho" className="hover:text-gray-600 transition">
						特定商取引法に基づく表記
					</Link>
					<Link to="/contact" className="hover:text-gray-600 transition">
						お問い合わせ
					</Link>
				</div>
			</footer>
		</main>
	);
}
